module.exports = __webpack_public_path__ + "img/history2.541961be.jpg";